export const STATUS_CUSTOM_MASTER = [
  { id: "active", title: "Active" },
  { id: "inactive", title: "InActive" },
];

export const STATUS_CUSTOM_OTHERS=[
  {id:'published',title:'Active'},
  {id:'inactive',title:'InActive'}
]

export const POSITION_LEVEL_OPTIONS=[
    { title: "Level 1", id: 1 },
    { title: "Level 2", id: 2 },
    { title: "Level 3", id: 3 },
    { title: "Level 4", id: 4 },
    { title: "Level 5", id: 5 },
    { title: "Level 6", id: 6 },
    { title: "Level 7", id: 7 },
    { title: "Level 8", id: 8 },
    { title: "Level 9", id: 9 },
    { title: "Level 10", id: 10 },
  ];

  export const STATUS_CUSTOM_APPLY=[
    {id:'eligible',title:'Eligible'},
    {id:'noteligible',title:'Not Eligible'}
  ]

export const SCHEDULE_STATUS = [
  { id: 'Applied', title: 'Applied' },
  { id: 'Interview Scheduled', title: 'Interview Scheduled' },
  { id: 'Rescheduling in Progress', title: 'Rescheduling in Progress' },
  { id: 'Interview Re-scheduled', title: 'Interview Rescheduled' },
  { id: 'Interview Completed', title: 'Interview Completed' },
  { id: 'Not-Empanelled', title: 'Not Empanelled' },
  { id: 'Empanelled', title: 'Empanelled' },
  { id: 'Rescheduling on Hold', title: 'Rescheduling on Hold'},
  { id: 'Rescheduling Cancelled', title: 'Rescheduling Cancelled'},
  { id: 'Reschedule Failed', title: 'Reschedule Failed'},
  { id: 'Interview On Hold', title: 'Interview on Hold'}
];

export const SCHEDULE_STATUS_INTERVIEWER = [
  { id: 'Interview Scheduled', title: 'Interview Scheduled' },
  { id: 'Rescheduling in Progress', title: 'Rescheduling in Progress' },
  { id: 'Interview Re-scheduled', title: 'Interview Rescheduled' },
  { id: 'Interview Completed', title: 'Interview Completed' },
  { id: 'Not-Empanelled', title: 'Not Empanelled' },
  { id: 'Empanelled', title: 'Empanelled' },
  { id: 'Rescheduling on Hold', title: 'Rescheduling on Hold'},
  { id: 'Rescheduling Cancelled', title: 'Rescheduling Cancelled'},
  { id: 'Reschedule Failed', title: 'Reschedule Failed'},
  { id: 'Interview On Hold', title: 'Interview on Hold'}
];

export const INTERVIEW_SLOT_STATUS = [
  { id: 'provided', title: 'Provided' },
  { id: 'notprovided', title: 'Not Provided' },
];


export const ELIGIBILITY_STATUS = [
  { id: 'provided', title: 'Provided' },
  { id: 'notprovided', title: 'Not Provided' },
];

export const QUERY_STATUS = [
  { id: "open", title: "Open" },
  { id: "closed", title: "Closed" },
];

export const ASSESSMENT_STATUS = [
  { id: 'completed', title: 'Completed' },
  { id: 'pending', title: 'Pending' },
  { id: 'notapplicable', title: 'Not Applicable' },
];

export const INFRACON_STATUS = [
  { id: 'verified', title: 'Verified' },
  { id: 'notverified', title: 'Not Verified' },
];

export const INFRACON_STATUS_REPORT = [
  { id: "verified", title: 'Verified' },
  { id: "verification under process", title: 'Verification Under Process' },
  { id: "verified with remarks", title: 'Verified With Remarks' },
  { id: "verification unsuccessful- discrepancy", title: 'Verification Unsuccessful- Discrepancy' },
];

export const EMPANELLED_STATUS_REPORT = [
  { id: "Empanelled", title: 'Empanelled' },
  { id: 'Not-Empanelled', title: 'Not Empanelled' },
];

export const CANDIDATE_SOURCE = [
  { id: 1, title: "Bid" },
  { id: 2, title: "Already Deployed" },
  { id: 3, title: "Infracon" },
];